import React from 'react';
import { cloneDeep } from 'lodash';
import Chevron from './Chevron';

export default class DashboardButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDropdown: false,
    };
  }

  componentDidMount = () => {
    window.addEventListener('click', this.handleClick);
    const { buttonDetails, button } = this.props;
    const { isDropdown } = buttonDetails;
    this.setState(
      {
        isDropdown,
      },
      () => {
        if (this.state.isDropdown) {
          this.setState({
            [`display${button}`]: false,
          });
        }
      }
    );
  };

  componentWillUnmount = () => {
    window.removeEventListener('click', this.handleClick);
  };

  handleClick = (e) => {
    let buttonToAffect;
    const { button } = this.props;
    const identifier = e.target.name || e.target.id;
    const displayOptions = cloneDeep(this.state[`display${button}`]);
    if (identifier.includes('-dropdown')) {
      buttonToAffect = identifier.slice(0, identifier.toString().indexOf('-'));
      return this.setState({
        [`display${buttonToAffect}`]: !displayOptions,
      });
    }
    if (this.state[`display${button}`]) {
      this.setState({
        [`display${button}`]: false,
      });
    }
  };

  handleAdmissionsOption = (option) => {
    window.open(option.value);
  };

  render() {
    const { buttonDetails, button } = this.props;
    const { isDropdown } = this.state;
    const caretTransform = this.state[`display${button}`] ? 270 : 90;
    const dropdownLabel = isDropdown ? buttonDetails.dropdownLabel : null;
    return !isDropdown ? (
      <button
        type="button"
        tabIndex={0}
        onClick={() => {
          this.handleAdmissionsOption(buttonDetails);
        }}
        className="button--primary take-action-learn-more-button margin-right"
      >
        {buttonDetails.label}
      </button>
    ) : (
      <div className="admissions-options">
        <button
          type="button"
          tabIndex={0}
          name={`${button}-dropdown`}
          className="button--primary take-action-learn-more-button margin-right"
        >
          {dropdownLabel}
          <Chevron
            color="#707070"
            transform={`rotate(${caretTransform}deg)`}
            idName={button}
            ariaLabel={`${
              this.state[`display${button}`]
                ? 'Click to close dropdown'
                : 'Click to open dropdown'
            }`}
          />
        </button>
        <div className="dropdown-options">
          {this.state[`display${button}`]
            ? buttonDetails.childButtons.map((option) => {
                return (
                  <div
                    role="button"
                    tabIndex={0}
                    className="individual-option"
                    key={option.label}
                    onClick={() => {
                      this.handleAdmissionsOption(option);
                    }}
                    onKeyDown={(e) => {
                      if (['Enter'].includes(e.key))
                        this.handleAdmissionsOption(option);
                    }}
                  >
                    {option.label}
                  </div>
                );
              })
            : null}
        </div>
      </div>
    );
  }
}
